'use client'

import dynamic from 'next/dynamic'
import type { ComponentType } from 'react'

/** Lesson bodies, code-split per lesson. Keys are curriculum slugs. Generated by scripts/gradient-registry.mjs. */
export const LESSON_COMPONENTS: Record<string, ComponentType> = {
  // 0 · Start Here
  'what-is-ml': dynamic(() => import('./what-is-ml')),
  'your-workbench': dynamic(() => import('./your-workbench')),
  // 1 · Code from Zero
  'values-and-variables': dynamic(() => import('./values-and-variables')),
  functions: dynamic(() => import('./functions')),
  'arrays-and-loops': dynamic(() => import('./arrays-and-loops')),
  'objects-and-classes': dynamic(() => import('./objects-and-classes')),
  'text-and-collections': dynamic(() => import('./text-and-collections')),
  'code-power-tools': dynamic(() => import('./code-power-tools')),
  'closures-and-recursion': dynamic(() => import('./closures-and-recursion')),
  'project-text-stats': dynamic(() => import('./project-text-stats')),
  // 2 · Numbers & Functions
  'number-line': dynamic(() => import('./number-line')),
  graphs: dynamic(() => import('./graphs')),
  algebra: dynamic(() => import('./algebra')),
  lines: dynamic(() => import('./lines')),
  'exponents-and-logs': dynamic(() => import('./exponents-and-logs')),
  'big-and-small-numbers': dynamic(() => import('./big-and-small-numbers')),
  trigonometry: dynamic(() => import('./trigonometry')),
  'sums-and-averages': dynamic(() => import('./sums-and-averages')),
  'project-growth': dynamic(() => import('./project-growth')),
  // 3 · Vectors & Matrices
  vectors: dynamic(() => import('./vectors')),
  'dot-product': dynamic(() => import('./dot-product')),
  matrices: dynamic(() => import('./matrices')),
  'matrix-multiplication': dynamic(() => import('./matrix-multiplication')),
  'tensors-and-broadcasting': dynamic(() => import('./tensors-and-broadcasting')),
  'eigenvectors-and-pca': dynamic(() => import('./eigenvectors-and-pca')),
  'project-recommender': dynamic(() => import('./project-recommender')),
  // 4 · Calculus: the Math of Change
  'slope-of-a-curve': dynamic(() => import('./slope-of-a-curve')),
  'derivative-rules': dynamic(() => import('./derivative-rules')),
  'chain-rule': dynamic(() => import('./chain-rule')),
  gradients: dynamic(() => import('./gradients')),
  'minima-and-saddles': dynamic(() => import('./minima-and-saddles')),
  integrals: dynamic(() => import('./integrals')),
  'project-curve-fitting': dynamic(() => import('./project-curve-fitting')),
  // 5 · Probability
  'probability-basics': dynamic(() => import('./probability-basics')),
  'conditional-and-bayes': dynamic(() => import('./conditional-and-bayes')),
  distributions: dynamic(() => import('./distributions')),
  'expected-value': dynamic(() => import('./expected-value')),
  softmax: dynamic(() => import('./softmax')),
  'cross-entropy': dynamic(() => import('./cross-entropy')),
  'maximum-likelihood': dynamic(() => import('./maximum-likelihood')),
  'entropy-and-kl': dynamic(() => import('./entropy-and-kl')),
  'project-naive-bayes': dynamic(() => import('./project-naive-bayes')),
  // 6 · Machine Learning
  'linear-regression': dynamic(() => import('./linear-regression')),
  'training-loop': dynamic(() => import('./training-loop')),
  'multiple-features': dynamic(() => import('./multiple-features')),
  'logistic-regression': dynamic(() => import('./logistic-regression')),
  multiclass: dynamic(() => import('./multiclass')),
  'evaluating-models': dynamic(() => import('./evaluating-models')),
  generalization: dynamic(() => import('./generalization')),
  'nearest-neighbors': dynamic(() => import('./nearest-neighbors')),
  'decision-trees': dynamic(() => import('./decision-trees')),
  clustering: dynamic(() => import('./clustering')),
  'project-house-prices': dynamic(() => import('./project-house-prices')),
  // 7 · Neural Networks
  'the-neuron': dynamic(() => import('./the-neuron')),
  'layers-and-mlps': dynamic(() => import('./layers-and-mlps')),
  backpropagation: dynamic(() => import('./backpropagation')),
  'backprop-for-layers': dynamic(() => import('./backprop-for-layers')),
  autograd: dynamic(() => import('./autograd')),
  'training-networks': dynamic(() => import('./training-networks')),
  'deep-training': dynamic(() => import('./deep-training')),
  regularization: dynamic(() => import('./regularization')),
  optimizers: dynamic(() => import('./optimizers')),
  convolutions: dynamic(() => import('./convolutions')),
  'project-digits': dynamic(() => import('./project-digits')),
  // 8 · Language Models
  tokenization: dynamic(() => import('./tokenization')),
  'bigram-model': dynamic(() => import('./bigram-model')),
  embeddings: dynamic(() => import('./embeddings')),
  word2vec: dynamic(() => import('./word2vec')),
  'neural-language-model': dynamic(() => import('./neural-language-model')),
  'recurrent-networks': dynamic(() => import('./recurrent-networks')),
  sampling: dynamic(() => import('./sampling')),
  'project-name-generator': dynamic(() => import('./project-name-generator')),
  // 9 · Transformers
  attention: dynamic(() => import('./attention')),
  'self-attention': dynamic(() => import('./self-attention')),
  'transformer-block': dynamic(() => import('./transformer-block')),
  'tiny-gpt': dynamic(() => import('./tiny-gpt')),
  'encoders-and-decoders': dynamic(() => import('./encoders-and-decoders')),
  'training-at-scale': dynamic(() => import('./training-at-scale')),
  scaling: dynamic(() => import('./scaling')),
  'project-your-gpt': dynamic(() => import('./project-your-gpt')),
  // 10 · The Frontier
  'pretraining-to-assistant': dynamic(() => import('./pretraining-to-assistant')),
  'fine-tuning-and-lora': dynamic(() => import('./fine-tuning-and-lora')),
  'retrieval-and-rag': dynamic(() => import('./retrieval-and-rag')),
  'reinforcement-learning': dynamic(() => import('./reinforcement-learning')),
  diffusion: dynamic(() => import('./diffusion')),
  multimodal: dynamic(() => import('./multimodal')),
  efficiency: dynamic(() => import('./efficiency')),
  'reasoning-and-agents': dynamic(() => import('./reasoning-and-agents')),
  evaluation: dynamic(() => import('./evaluation')),
  'safety-and-alignment': dynamic(() => import('./safety-and-alignment')),
  'whats-next': dynamic(() => import('./whats-next')),
}
